import Handlebars from "handlebars";
import fechaTemplate from "../handlebars/fechaTemplate.hbs";
import lugarTemplate from "../handlebars/lugarTemplate.hbs";
import eventosTemplate from "../handlebars/eventosTemplate.hbs";
import asistentesTemplate from "../handlebars/asistentesTemplate.hbs";
import grabacionTemplate from "../handlebars/grabacionTemplate.hbs";
import imagenTemplate from "../handlebars/imagenTemplate.hbs";
import imagenTemplateYes from "../handlebars/imagenTemplateYes.hbs";
import microfonosTemplate from "../handlebars/microfonosTemplate.hbs";
import sonidoTemplate from "../handlebars/sonidoTemplate.hbs";
import sonidoTemplateYes from "../handlebars/sonidoTemplateYes.hbs";
import streamingTemplate from "../handlebars/streamingTemplate.hbs";
import videoconferenciaTemplate from "../handlebars/videoconferenciaTemplate.hbs";
import totalTemplate from "../handlebars/totalTemplate.hbs";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";

let formData = {
  fecha: null,
  dias: 1,
  horaInicio1: "9:00",
  horaFin1: "12:00",
  horaInicio2: "9:00",
  horaFin2: "12:00",
  horaInicio3: "9:00",
  horaFin3: "12:00",
  lugarEvento: null,
  lugar: null,
  tipoEvento: null,
  asistentes: null,
  grabacion: null,
  imagen: null,
  microfonos: null,
  sonido: null,
  streaming: null,
  videoconferencia: null,
  totalPrice: 0,
};

export class Mediator {
  constructor() {
    this.maxDays = 3;
    this.app = document.getElementById("app");
    // Add totalTemplate as the final screen
    this.screenOrder = [
        "eventosTemplate"
      ];
      
    this.currentTemplate = "eventosTemplate";
    this.screensMapping = {
      fechaTemplate: {template:fechaTemplate, templateName:"fechaTemplate", code:"fecha", icon:"fecha.svg"},
      lugarTemplate: {template:lugarTemplate, templateName:"lugarTemplate", code:"lugar", icon:"lugar.svg"},
      eventosTemplate: {template:eventosTemplate, templateName:"eventosTemplate", code:"tipoEvento", icon:"editar.svg"},
      asistentesTemplate: {template:asistentesTemplate, templateName:"asistentesTemplate", code:"asistentes", icon:"asistentes.svg"},
      grabacionTemplate: {template:grabacionTemplate, templateName:"grabacionTemplate", code:"grabacion", icon:"grabacion.svg"},
      imagenTemplate: {template:imagenTemplate, templateName:"imagenTemplate", code:"multimedia", icon:"imagen.svg"},
      imagenTemplateYes: {template:imagenTemplateYes, templateName:"imagenTemplateYes", code:"multimedia", icon:"imagen.svg"},
      microfonosTemplate: {template:microfonosTemplate,templateName:"microfonosTemplate", code:"microfonos", icon:"microfonos.svg"},
      sonidoTemplate: {template:sonidoTemplate, templateName:"sonidoTemplate", code:"sonido", icon:"sonido.svg"},
      sonidoTemplateYes: {template:sonidoTemplateYes, templateName:"sonidoTemplateYes", code:"sonido", icon:"sonido.svg"},
      streamingTemplate: {template:streamingTemplate, templateName:"streamingTemplate", code:"streaming", icon:"streaming.svg"},
      videoconferenciaTemplate: {template:videoconferenciaTemplate, templateName:"videoconferenciaTemplate", code:"videoconferencia", icon:"videoconferencia.svg"},
      totalTemplate: {template:totalTemplate, templateName:"totalTemplate", code:"total", icon:"total.svg"}
    };
  }

  init() {
    this.initData();
    this.setScreenOrder(0);
    this.renderScreen();
  }

  initData() {
    const dataArr=[
      "ruedaDePrensa",
      "reunionCurso",
      "evento-50",
      "evento50-100",
      "evento100-200",
      "evento200-300"
    ]
    dataArr.forEach((dataName) => {
      fetch(`/project/data/catalog/${dataName}.json`)
        .then(response => response.json())
        .then(data => {
          console.log(`Datos iniciales cargados para ${dataName}:`, data);
          localStorage.setItem(dataName, JSON.stringify(data));
        });
    });
  }

  setScreenOrder(order) {
    formData.dias = 1;
    this.maxDays = 1;
    if(order==1) this.screenOrder = ["eventosTemplate", "fechaTemplate", "imagenTemplate", "sonidoTemplateYes", "totalTemplate"];
    if(order==2) {
      this.screenOrder = ["eventosTemplate", "fechaTemplate", "asistentesTemplate", "imagenTemplate",  "sonidoTemplate", "streamingTemplate", "videoconferenciaTemplate", "totalTemplate"];
      this.maxDays = 3;
    }
    if(order==3) this.screenOrder = ["eventosTemplate", "fechaTemplate", "imagenTemplateYes", "sonidoTemplateYes", "totalTemplate"];
  }

  setMenuSelection(){
    document.querySelectorAll(".menuItem").forEach((elem) => {
      elem.style.display="none";
      if(this.screenOrder.indexOf(elem.dataset.hbs) > 0){
        if(this.currentTemplate!="eventosTemplate" && this.currentTemplate!="totalTemplate"){
          elem.style.display="flex";
        }
      }
      elem.classList.remove('selected');
    });
    document.querySelector(`.menuItem[data-hbs="${this.currentTemplate}"]`)?.classList.add('selected');
  }

  fillTemplate(obj, template, target) {
    template = Handlebars.compile(template);
    target.innerHTML = template(obj);
  }  

  renderScreen() {
    const screen = this.screensMapping[this.currentTemplate];
    if (screen) {
      let previusTemplate =  this.screensMapping[this.screenOrder[this.screenOrder.indexOf(this.currentTemplate) - 1]];
      let nextTemplate =  this.screensMapping[this.screenOrder[this.screenOrder.indexOf(this.currentTemplate) + 1]];
      if(this.currentTemplate==="totalTemplate"){
        let formData = this.computeTotal();
        this.fillTemplate({previusTemplate, nextTemplate, screen, formData}, screen.template, this.app);
      }else{
        this.fillTemplate({previusTemplate, nextTemplate, screen}, screen.template, this.app);
      }
      this.setMenuSelection();
      this.app.querySelector(`.card[data-value="${formData[screen.code]}"]`)?.classList.add('selected');
      if(this.currentTemplate==="fechaTemplate"){
        this.initCalendar();
      }
      this.addTemplateHandlers();
    } else {
      console.warn(`No se encontró template para "${screen.template}"`);
    }
  }

  initCalendar() {
    const calendarEl = this.app.querySelector("#calendar");
    if (calendarEl) {
      let mode="single";
      if(this.maxDays>1) mode="multiple";
      flatpickr(calendarEl, {
        inline: true,
        mode: mode,
        defaultDate: formData.fecha,
        onChange: (selectedDates, dateStr, instance) => {
          this.calendarChange(selectedDates, dateStr, instance);
        }
      });
    }
    this.setHoursVisibility(formData.dias);
  }

  calendarChange(selectedDates, dateStr, instance) {
    if (selectedDates.length > this.maxDays) {
      selectedDates.pop();
    }
    if (this.hayDiasNoConsecutivos(dateStr)) {
      alert("Por favor, seleccione días consecutivos.");
      selectedDates.pop();
    }
    instance.setDate(selectedDates);
    formData.fecha = dateStr;    
    formData.dias = selectedDates.length;    
    this.setHoursVisibility(selectedDates.length);
  }
  setHoursVisibility(dias){
    if(formData.tipoEvento==="rueda de prensa"){
      document.querySelector("#horafin1Container").style.display="none";
    }else{
      document.querySelector("#horafin1Container").style.display="flex";
    }
    this.app.querySelectorAll(".hora-content").forEach((elem,key) => {
      if(key<dias){
        elem.style.display="flex";
      } else {
        elem.style.display="none";
      }
    }); 
    this.app.querySelectorAll(".formDataChange").forEach((elem) => {
      elem.value = formData[elem.dataset.id] || "";
    });
  }
  
  hayDiasNoConsecutivos(fechasString) {
    const fechas = fechasString
      .split(",")
      .map(fecha => fecha.trim())
      .filter(Boolean)
      .map(fecha => {
        const [anio, mes, dia] = fecha.split("-").map(Number);
        return Date.UTC(anio, mes - 1, dia);
      })
      .sort((a, b) => a - b);

    const unDia = 24 * 60 * 60 * 1000;

    for (let i = 1; i < fechas.length; i++) {
      const diferencia = fechas[i] - fechas[i - 1];

      if (diferencia !== unDia) {
        return true;
      }
    }

    return false;
  }

  addTemplateHandlers() {
    this.app.querySelectorAll(".formData").forEach((elem) => {
      elem.addEventListener("click", (ev) => {
        const siblings = ev.currentTarget.parentElement.querySelectorAll(".formData");
        siblings.forEach((sibling) => sibling.classList.remove("selected"));
        ev.currentTarget.classList.add("selected");
        this.setData(ev.currentTarget.dataset);
      });
    });
    this.app.querySelectorAll(".formDataChange").forEach((elem) => {
      elem.addEventListener("change", (ev) => {
        ev.currentTarget.dataset.value = ev.currentTarget.value;
        this.setData(ev.currentTarget.dataset);
      });
    });

    this.app.querySelectorAll(".arrow").forEach((elem) => {  
      elem.addEventListener("click", (ev) => {
        this.currentTemplate = ev.currentTarget.dataset.template;
        this.renderScreen();
      });
    });
    this.app.querySelectorAll("#printPDF").forEach((elem) => {  
      elem.addEventListener("click", (ev) => {
        this.printPDF();
      });
    });
  }

  setData(dataset) {
    formData[dataset.id] = dataset.value;
    console.log(`Actualizado formData.${dataset.id}:`, dataset.value);  
    if(dataset.order){
      document.querySelector(".right").style.display="flex";
      this.setScreenOrder(parseInt(dataset.order));
    }
  }

  printPDF() {
    const element = document.getElementById('PrintTable');
    const opt = {
      margin: 10,
      filename: 'presupuesto-telesonic.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 4 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
    };
    
    // Usar html2pdf que está disponible globalmente
    if (window.html2pdf) {
      window.html2pdf().set(opt).from(element).save();
    } else {
      console.error('html2pdf no está cargado');
      alert('Error al generar PDF. Por favor, recarga la página.');
    }
  }

  computeTotal() {
    // Base pricing
    let caso = this.getPriceData(formData);
      if (formData.tipoEvento==="rueda de prensa") {
        if (formData.imagen==="no") {
          caso = caso.filter(item => item.actividad !== "imagen");
        }
      } else if (formData.tipoEvento==="reunion" || formData.tipoEvento==="curso") {
        if (this.convertirAMinutos(formData.horaFin1) - this.convertirAMinutos(formData.horaInicio1) > 180) {
          caso.find(item => item.actividad === "montaje").precio = caso.find(item => item.actividad === "montaje").precioCompleto;
          caso.find(item => item.actividad === "montaje").lista= ["Asistencia técnica 1 jornada"];
        }
      } else {
        let utilities="";
        if (formData.imagen==="no") {
          caso = caso.filter(item => item.actividad !== "imagen");
        }else{
          caso.find(item => item.actividad === "imagen").precio = caso.find(item => item.actividad === "imagen").precio*this.getDaysPrice(formData.dias);
          caso.find(item => item.actividad === "montaje").lista.push("Montaje de Imagen");
          caso.find(item => item.actividad === "asistencia").lista.push("Asistencia Imagen");
          utilities+="i";
        }
        if (formData.sonido==="no") {
          caso = caso.filter(item => item.actividad !== "sonido");
        }else{
          caso.find(item => item.actividad === "sonido").precio = caso.find(item => item.actividad === "sonido").precio*this.getDaysPrice(formData.dias);
          caso.find(item => item.actividad === "montaje").lista.push("Montaje de Sonido");
          caso.find(item => item.actividad === "asistencia").lista.push("Asistencia Sonido");
          utilities+="s";
        }
        if (formData.streaming==="no") {
          caso = caso.filter(item => item.actividad !== "streaming");
        }else{
          caso.find(item => item.actividad === "streaming").precio = caso.find(item => item.actividad === "streaming").precio*this.getDaysPrice(formData.dias);
          caso.find(item => item.actividad === "montaje").lista.push("Montaje de Streaming");
          caso.find(item => item.actividad === "asistencia").lista.push("Asistencia Streaming");
          utilities+="v";
        }
        if (formData.videoconferencia==="no") {
          caso = caso.filter(item => item.actividad !== "videoconferencia");
          caso = caso.filter(item => item.actividad !== "videoconferencianostreaming");
        }else{
          if (formData.streaming==="si") {
            caso = caso.filter(item => item.actividad !== "videoconferencianostreaming");
            caso.find(item => item.actividad === "videoconferencia").precio = caso.find(item => item.actividad === "videoconferencia").precio*this.getDaysPrice(formData.dias);
          } else {
            caso = caso.filter(item => item.actividad !== "videoconferencia");
            caso.find(item => item.actividad === "videoconferencianostreaming").precio = caso.find(item => item.actividad === "videoconferencianostreaming").precio*this.getDaysPrice(formData.dias);
          }
          caso.find(item => item.actividad === "montaje").lista.push("Montaje de Videoconferencia");
          caso.find(item => item.actividad === "asistencia").lista.push("Asistencia Videoconferencia");
          /*
          if(!utilities.includes("v")) {
            utilities+="v";
          }
          */
        }
        caso.find(item => item.actividad === "montaje").precio = caso.find(item => item.actividad === "montaje").pricelist[utilities];
        if (this.convertirAMinutos(formData.horaFin1) - this.convertirAMinutos(formData.horaInicio1) > 180) {
          caso.find(item => item.actividad === "asistencia").precio = caso.find(item => item.actividad === "asistencia").pricelistCompleto[utilities];
        } else {
          caso.find(item => item.actividad === "asistencia").precio = caso.find(item => item.actividad === "asistencia").pricelistMedio[utilities];
        }
        if(formData.dias>1){
          if (this.convertirAMinutos(formData.horaFin2) - this.convertirAMinutos(formData.horaInicio2) > 180) {
            caso.find(item => item.actividad === "asistencia").precio += caso.find(item => item.actividad === "asistencia").pricelistCompleto[utilities];
          } else {
            caso.find(item => item.actividad === "asistencia").precio += caso.find(item => item.actividad === "asistencia").pricelistMedio[utilities];
          }
        }
        if(formData.dias>2){
          if (this.convertirAMinutos(formData.horaFin3) - this.convertirAMinutos(formData.horaInicio3) > 180) {
            caso.find(item => item.actividad === "asistencia").precio += caso.find(item => item.actividad === "asistencia").pricelistCompleto[utilities];
          } else {
            caso.find(item => item.actividad === "asistencia").precio += caso.find(item => item.actividad === "asistencia").pricelistMedio[utilities];
          }
        }
    }
    formData.sitioFecha = this.getSitioFecha();
    formData.comentarios = caso.find(item => item.actividad === "comentarios")?.lista || [];
    caso = caso.filter(item => item.actividad !== "comentarios");
    formData.totalPrice = caso.reduce((total, item) => total + item.precio, 0);
    formData.ivaPrice = (formData.totalPrice * 1.21).toFixed(2);
    formData.itemList = caso;
      

    console.log(formData);
    return formData;
  
  }  
  getSitioFecha(){
    let fechaStr = "En "+formData.lugarEvento+", ";
    if(formData.fecha){
      if(formData.tipoEvento==="rueda de prensa"){
        fechaStr += formData.fecha+"("+formData.horaInicio1+")";
        return fechaStr;
      }
      const fechas = formData.fecha.split(",");
      fechaStr += fechas.map((fecha, index) => `${fecha}(${formData["horaInicio"+(index+1)]} - ${formData["horaFin"+(index+1)]})`).join(", ");
    }
    return fechaStr;
  }
  convertirAMinutos (hora) {
    const [horas, minutos] = hora.split(":").map(Number);
    return horas * 60 + minutos;
  }

  getDaysPrice(dias) {
    if (dias === 2) {
      return 1.5;
    }
    if (dias === 3) {
      return 2;
    }
    return 1;
  }

  getPriceData(formData) {
    if (formData.tipoEvento === "rueda de prensa") {
      return JSON.parse(localStorage.getItem("ruedaDePrensa"));
    } else if (formData.tipoEvento === "reunion" || formData.tipoEvento === "curso") {
      return JSON.parse(localStorage.getItem("reunionCurso"));
    }else if (formData.asistentes==="-50") {
      return JSON.parse(localStorage.getItem("evento-50"));
    }else if (formData.asistentes==="50-100") {
      return JSON.parse(localStorage.getItem("evento50-100"));
    }else if (formData.asistentes==="100-200") {
      return JSON.parse(localStorage.getItem("evento100-200"));
    }else if (formData.asistentes==="200-300") {
      return JSON.parse(localStorage.getItem("evento200-300"));
    }
  }
}